module.exports = __webpack_public_path__ + "img/46_8.ce2cbfc7.png";